export default "__VITE_ASSET__$Kfzt0rG__"